module.exports = __webpack_public_path__ + "static/img/be42328.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/lhsx/2.png
// module id = 254
// module chunks = 2